import { SettingsPage } from "../settings/settings-page";
import { type Component } from "solid-js";
import { type Page } from "@saludio/core";
import { type PageIdentifier, type PluginEntry } from "../types";

type PageRendererProps = {
  pageId: PageIdentifier | null;
  pluginEntry: PluginEntry | null;
  pluginEntries: Array<PluginEntry>;
  onBack: () => void;
};

export const PageRenderer: Component<PageRendererProps> = (props) => {
  const title = () => (props.pluginEntry ? props.pluginEntry.name : "Settings");

  return (
    <div>
      <div class="Page">
        <header class="Page__Header">
          <div class="Page__Header__Title">
            <button onClick={props.onBack}>
              {/* Origin: https://icons.getbootstrap.com/icons/arrow-left-short/ */}
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                <path
                  fill-rule="evenodd"
                  d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                />
              </svg>
            </button>
            <h2>{title()}</h2>
          </div>
          {(() => {
            const page = props.pluginEntry?.registration?.page as Page | undefined;
            const PageAction = page?.pageAction;
            return PageAction ? (
              <div class="Page__Header__Action">
                <PageAction />
              </div>
            ) : null;
          })()}
        </header>
        <main class="Page__Content">
          {(() => {
            // Handle settings page
            if (props.pageId === "settings") {
              return <SettingsPage plugins={props.pluginEntries} />;
            }

            // Handle plugin pages
            if (typeof props.pageId === "string") {
              const pluginId = props.pageId;

              const PageComponent = props.pluginEntry?.registration?.page;
              return PageComponent ? <PageComponent /> : null;
            }

            return null;
          })()}
        </main>
      </div>
    </div>
  );
};
